<button
  ds-button
  type="button"
  class="share-btn"
  [variant]="DsButtonVariants.secondary"
  [icon]="Icons.ShareNodes"
  [iconStyle]="IconStyles.Regular"
  title="{{ 'action_share' | translate }}"
  (click)="openShareIssueModal()"
>
  {{ 'action_share' | translate }}
</button>
